class InputValidateService {
  nameValidation(name) {
    if (!name || name.length === 0) {
      return {
        'success': false,
        'message': 'Campo obrigatório'
      }
    }
    if (name.length < 3){
      return {
        'success': false,
        'message': 'Nome muito curto'
      }
    }
    if (name.length > 50) {
      return {
        'success': false,
        'message': 'Nome muito longo'
      }
    }
    return { 'success': true }
  }

  birthDateValidation(birthDate) {
    if (!birthDate || birthDate.length === 0) {
      return {
        'success': false,
        'message': 'Campo obrigatório'
      }
    } else if (!this.validarData(birthDate)) {
      return {
        'success': false,
        'message': 'Data inválida'
      }
    } else {
      return {
        'success': true
      }
    }
  }

  validarData = (data) => {
    const [dia, mes, ano] = data.split('/')
    const d = new Date(`${ano}-${mes}-${dia}`)
    const hoje = new Date()
    return (
      /^\d{2}\/\d{2}\/\d{4}$/.test(data) &&
      d <= hoje
    )
  }

  emailValidation(email) {
    if (!email || email.length === 0) {
      return {
        'success': false,
        'message': 'Campo obrigatório'
      }
    } else if (!this.validarEmail(email)) {
      return {
        'success': false,
        'message': 'Email inválido'
      }
    } else {
      return {
        'success': true
      }
    }
  }

  validarEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
  }

  cpfValidation(cpf) {
    const onlyDigits = cpf.replace(/\D/g, '');
    if (!cpf || onlyDigits.length === 0) {
      return {
        'success': false,
        'message': 'Campo obrigatório'
      }
    } else if (!this.validarCPF(onlyDigits)) {
      return {
        'success': false,
        'message': 'CPF inválido'
      }
    } else {
      return {
        'success': true
      }
    }
  }

  validarCPF = (cpf) => {
    cpf = cpf.replace(/[^\d]+/g, '')
    if (cpf.length !== 11 || /^(\d)\1+$/.test(cpf)) return false

    let soma = 0
    for (let i = 0; i < 9; i++) soma += parseInt(cpf.charAt(i)) * (10 - i)
    let resto = 11 - (soma % 11)
    if (resto === 10 || resto === 11) resto = 0
    if (resto !== parseInt(cpf.charAt(9))) return false

    soma = 0
    for (let i = 0; i < 10; i++) soma += parseInt(cpf.charAt(i)) * (11 - i)
    resto = 11 - (soma % 11)
    if (resto === 10 || resto === 11) resto = 0
    return resto === parseInt(cpf.charAt(10))
  }

  phoneValidation(phone) {
    const onlyDigits = phone.replace(/\D/g, '')
    if (!onlyDigits || onlyDigits.length === 0) {
      return {
        'success': false,
        'message': 'Campo obrigatório'
      }
    } else if (!this.validarCelular(phone)) {
      return {
        'success': false,
        'message': 'Celular inválido'
      }
    } else {
      return {
        'success': true
      }
    }
  }

  validarCelular = (cel) => {
    return /^\(\d{2}\) \d{5}-\d{4}$/.test(cel)
  }
}

const inputValidateService = new InputValidateService()

export default inputValidateService